/* Libraries */
import styled from 'styled-components';

const FacebookContainer=styled.div`
  max-width: 500px;
  display: block;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 4rem;

`;

export default FacebookContainer;



// WEBPACK FOOTER //
// ./src/components/ArticleContent/FacebookContainer.js